import React from "react";
import { Typography } from "@mui/material";

export const SettingsHeader: React.FC<{ title: string; children?: React.ReactNode }> = ({
  title,
  children,
}) => (
  <Typography
    variant="h6"
    style={{ margin: "10px 0px", display: "flex", alignItems: "center", width: "100%" }}
  >
    <span style={{ marginRight: "10px" }}>{title}</span>
    {children}
  </Typography>
);
